import axios from "axios";
import { VatNumberRules } from "./VatNumberRules";

export class Country{
    public idCountry : string;
    public name : string;
    public code : string;
    public code3 : string;
    public numeric : string;
    public codeType : string;
    public fullVisibility : boolean;
    public idCountryFather : string;
    public isManagedBySAP : boolean;
    public emailContact : string;
    public showCommunication: boolean;

    public vatNumberRule : VatNumberRules;

    constructor(
        idCountry? : string,
        name? : string,
        code? : string,
        code3? : string,
        numeric? : string,
        codeType? : string,
        fullVisibility? : boolean,
        idCountryFather? : string,
        isManagedBySAP? : boolean,
        emailContact? : string,
        showCommunication? : boolean,
    ){
        this.idCountry = idCountry;
        this.name = name;
        this.code = code;
        this.code3 = code3;
        this.numeric = numeric;
        this.codeType = codeType;
        this.fullVisibility = fullVisibility;
        this.idCountryFather = idCountryFather;
        this.isManagedBySAP = isManagedBySAP; 
        this.emailContact = emailContact;
        this.showCommunication = showCommunication;
    }
}